import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FC } from 'react';
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

import { FormDataT } from '..';
import FileCard from './FileCard';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Badge = styled(Text)<{ $isDragging: boolean }>`
  width: 32px;
  height: 21px;
  border-radius: 100px;
  background: rgba(248, 248, 248, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      cursor: grabbing;
    `}
`;

const Card = styled.div`
  flex: 1;
`;

interface Props {
  index: number;
  remove: UseFieldArrayRemove;
  part: FieldArrayWithId<FormDataT, 'parts', 'id'>;
}

const SortableTip: FC<Props> = ({ remove, part, index }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: part.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Wrap ref={setNodeRef} style={style} {...attributes}>
      <Badge
        as="div"
        $type="smallHeadline"
        {...listeners}
        $isDragging={isDragging}
      >
        {index + 1}
      </Badge>
      <Card>
        <FileCard part={part} remove={() => remove(index)} />
      </Card>
    </Wrap>
  );
};

export default SortableTip;
